import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const ActionGroup = styled.div`
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.5s;

    *:hover > * > & {
        opacity: 1;
        transform: translateX(0);
    }
`
